import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import { Check } from 'lucide-react';
import { useUnsafeTranslation } from '../../../../i18next';
import { FlexContainer } from '../../../../layout/Flex';

const StepCircle = styled('div')<{ state: 'done' | 'active' }>((p) => ({
  width: 24,
  height: 24,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  fontSize: p.theme.custom.fontSize.s,
  color: 'white',
  background:
    p.state === 'done'
      ? p.theme.custom.colors.green.w500
      : p.theme.custom.colors.blue.w500
}));

const Connector = styled('div')((p) => ({
  height: 1,
  width: 64,
  background: p.theme.custom.colors.gray.w300,
  margin: `0 ${p.theme.spacing(2)}px`
}));

const StepLabel = styled(Typography)<{ active: boolean }>((p) => ({
  marginLeft: p.theme.spacing(1),
  fontWeight: p.active ? 600 : 400,
  color: p.active
    ? p.theme.custom.colors.gray.w900
    : p.theme.custom.colors.gray.w500
}));

/** Two-step progress header: "Select employee" (done) → "Resolve clashes". */
export const MergeStepper = () => {
  const { t } = useUnsafeTranslation();
  return (
    <FlexContainer alignItems="center">
      <FlexContainer alignItems="center">
        <StepCircle state="done">
          <Check size={14} />
        </StepCircle>
        <StepLabel variant="body2" active={false}>
          {t('Select employee')}
        </StepLabel>
      </FlexContainer>
      <Connector />
      <FlexContainer alignItems="center">
        <StepCircle state="active">2</StepCircle>
        <StepLabel variant="body2" active={true}>
          {t('Resolve clashes')}
        </StepLabel>
      </FlexContainer>
    </FlexContainer>
  );
};
